import React from 'react';

function About() {
  return <h2>About From another file</h2>;
}

export default About;
